// POC config
// const SQUIZ_SERVER = "dxp-us-search.funnelback.squiz.cloud";
// const SQUIZ_COLLECTION =
//   "489b6fea-b9bf-4672-b021-08279da0525d~sp-origin-energy";

// Origin prod config
// const SQUIZ_SERVER = "https://dxp-au-search.funnelback.squiz.cloud";
const SQUIZ_SERVER = "/squiz";
const getSquizCollection = (env: EnvironmentNames) =>
  env === "prod" ? "orie~sp-origin-enegy" : "orie~sp-origin-energy-staging";

export const getSquizSearchDefaultOptions = (
  env: EnvironmentNames
): ISquizSearchOptions => ({
  server: SQUIZ_SERVER,
  collection: getSquizCollection(env),
  num_ranks: "9",
  linkto: "",
  profile: `${env === "prod" ? "json" : "json-staging"}`,
  query: "!padrenull",
});

export const getSquizSuggestDefaultOptions = (
  env: EnvironmentNames
): ISquizSuggestOptions => ({
  server: SQUIZ_SERVER,
  collection: getSquizCollection(env),
  partial_query: "",
  fmt: "json++", // seems it has to be this to get full results.
});

export interface ISquizSearchResult {
  rank: number;
  // score: number,
  title: string;
  // collection: string,
  // component: number,
  // collapsed: null,
  liveUrl: string;
  summary: string;
  allSummaryText: null;
  // cacheUrl: string,
  // date: number,
  // fileSize: number,
  // fileType: string,
  // tier: number,
  // docNum: number,
  // exploreLink: null,
  // kmFromOrigin: null,
  listMetadata?: {
    image?: string[]; // image URL
    c?: string[]; // appears to hold the meta tag description
  };
  // tags: string[], // ?
  // quickLinks: null,
  displayUrl: string;
  clickTrackingUrl: string;
  // explain: null,
  // indexUrl: string,
  // gscopesSet: [],
  // customData: {},
  // relatedDocuments: {},
  // documentVisibleToUser?: boolean,
  // promoted?: boolean,
  // diversified?: boolean
}

export interface ISquizPagination {
  label: string;
  url: string;
  selected: boolean;
}

export interface ISquizSearchResponse {
  collection: {
    profiles: {
      stencil: {
        id: string;
        facetedNavConfConfig: {
          facetDefinitions: [
            {
              name: string;
              categoryDefinitions: [
                {
                  facetName: string; // eg 'Tabs'
                  data: string; // eg "All Results",
                  // "label": null,
                  // "subCategories": [],
                  queryStringCategoryExtraPart: string; //"AllDocumentsFill",
                  allQueryStringParamNames: string[];
                  // "f.Tabs|AllDocumentsFill"
                  queryStringParamName: string; // "f.Tabs|AllDocumentsFill"
                }
              ];
            }
          ];
        };
      };
    };
  };
  question: {
    query: string;
    originalQuery: string; // not sure what this is for
  };
  response: {
    resultPacket: {
      fullyMatching?: number;
      collapsed?: number;
      partiallyMatching?: number;
      totalMatching?: number; // = fullyMatching + partiallyMatching
      estimatedCounts?: boolean;
      carriedOverFtd?: number;
      totalDistinctMatchingUrls?: number;
      numRanks?: number;
      currStart?: number;
      currEnd?: number;
      prevStart?: number;
      nextStart?: number;
      totalSecurityObscuredUrls?: number;
      anyUrlsPromoted?: boolean;
      resultDiversificationApplied?: boolean;
      results: ISquizSearchResult[];
      contextualNavigation: {
        // appears to be related-searches ?
        searchTerm: string;
        categories: [
          {
            name: "type" | "topic"; // what are these?
            more: number;
            moreLink: string;
            fewerLink: string;
            clusters: [
              {
                href: string;
                count: number;
                label: string;
                query: string;
              }
            ];
          }
        ];
      };
      resultsSummary: {
        fullyMatching: number;
        // "collapsed": 0,
        partiallyMatching: 0;
        totalMatching: number;
        estimatedCounts: boolean;
        // "carriedOverFtd": null,
        // "totalDistinctMatchingUrls": null,
        // "numRanks": 10,
        currStart: number;
        currEnd: number;
        prevStart: number;
        nextStart: number;
        // "totalSecurityObscuredUrls": null,
        // "anyUrlsPromoted": false,
        // "resultDiversificationApplied": false
      };
      qsups?: [
        {
          // query substitutions.  add qsup=off to query to search without
          src: string;
          query: string;
        }
      ];
      spell: {
        url: string;
        text: string;
      };
    };
    facets: [
      {
        name: string; // Like 'Tabs'
        unselectAllUrl: string;
        allValues: [
          {
            data: string; // All Results,
            label: string; // All Results,
            count: number; // 733,
            selected: boolean; //true,
            toggleUrl: string; // ?query=board&profile=stencil&collection=489b6fea-b9bf-4672-b021-08279da0525d%7Esp-origin-energy
          }
        ];
      }
    ];
    customData: {
      stencils: {
        pagination: {
          first?: ISquizPagination;
          previous?: ISquizPagination;
          next?: ISquizPagination;
          pages?: ISquizPagination[];
        };
        tabs: {
          selected: string;
        };
      };
    };
  };
}

export interface ISquizSuggestion {
  key: string;
  disp: any; // the thing to display - could be an object
  disp_t: "T" | "H" | "J" | "C"; // text/html/json/callback
  wt: string;
  cat: string;
  // "cat_t": string,
  action: string;
  action_t: "C" | "U" | "Q" | "E" | "S"; // callback/url/query/extending-a-query/system
}

export type ISquizSuggestResponse = ISquizSuggestion[];

export interface ISquizSearchOptions {
  profile?: string;
  server?: string;
  sort?: string;
  num_ranks?: string;
  collection?: string;
  query?: string;
  linkto?: string;
  title?: string;
}

// https://docs.squiz.net/funnelback/docs/latest/reference/modern-ui/suggest-json.html
export interface ISquizSuggestOptions {
  profile?: string;
  server?: string;
  sort?: 0 | 1 | 2;
  collection?: string;
  partial_query: string;
  fmt?: string;
  alpha?: number;
}

export function squizBaseUrl(server: string = SQUIZ_SERVER) {
  return `${server}`;
}

function squizBaseSearchUrl(server: string = SQUIZ_SERVER) {
  return `${squizBaseUrl(server)}/s/search.json`;
}

function squizBaseSuggestUrl(server: string = SQUIZ_SERVER) {
  return `${squizBaseUrl(server)}/s/suggest.json`;
}

export function squizCreateQueryString(r: ISquizSearchOptions) {
  const profile = r.profile ? `&profile=${r.profile}` : "";

  const url = `&num_ranks=${r.num_ranks}&collection=${r.collection}&query=${r.query}${profile}`;

  return url;
}

export function squizBuildSearchURL(r: ISquizSearchOptions) {
  const url = `${squizBaseSearchUrl(r.server)}?${squizCreateQueryString(r)}`;

  return url;
}

// convert an object's key/values into a query string
function objToQueryString(o: Record<string, any>): string {
  const urlSearchParams = Object.entries(o).reduce((accum, [k, v]) => {
    accum.set(k, v);
    return accum;
  }, new URLSearchParams());

  return urlSearchParams.toString();
}

// perform a search using given search options
export async function squizSearch(
  options: ISquizSearchOptions
): Promise<ISquizSearchResponse | undefined> {
  try {
    const url = squizBuildSearchURL(options);
    const r = await fetch(url);
    return (await r.json()) as ISquizSearchResponse;
  } catch (e) {
    console.error(e);
  }
  return undefined;
}

// perform a search using the base search URL + a pre-baked search query
// the pre-baked queries are handed to us by squiz in JSON responses
export async function squizSearchWithParams(
  options: ISquizSearchOptions,
  paramStr?: string
): Promise<ISquizSearchResponse | undefined> {
  try {
    const url = `${squizBaseSearchUrl(options.server)}${paramStr}`;
    const response = await fetch(url);
    return (await response.json()) as ISquizSearchResponse;
  } catch (e) {
    console.error(e);
  }
  return undefined;
}

export async function squizSuggest(
  options: ISquizSuggestOptions
): Promise<ISquizSuggestResponse | undefined> {
  try {
    const { server, ...rest } = options;
    const queryParams = objToQueryString(rest);
    const url = `${squizBaseSuggestUrl(server)}?${queryParams}`;
    const response = await fetch(url);
    return (await response.json()) as ISquizSuggestResponse;
  } catch (e) {
    console.error(e);
  }
  return undefined;
}
